require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./domestic-violence-reduction-unit.json") })
        }
      }, "path---domestic-violence-reduction-unit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---domestic-violence-reduction-unit!./.cache/json/domestic-violence-reduction-unit.json
// module id = 878
// module chunks = 231608221292675